import React, { useState, useEffect } from 'react';
import './mugram.css';
import mugramicon from '../../icon/instagram.png';
import Story from '../../component/story/Story';

const API_URL = 'http://185.164.73.170:5000';

export default function Mugram(props) {
    const [posts, setPosts] = useState([]);
    const [likedPosts, setLikedPosts] = useState(() => {
        const savedLikes = localStorage.getItem('likedPosts');
        return savedLikes ? JSON.parse(savedLikes) : [];
    });

    const [imageIndexes, setImageIndexes] = useState({});

    useEffect(() => {
        fetch(`${API_URL}/posts`)
            .then((res) => res.json())
            .then((data) => {
                setPosts(data);
                const initialIndexes = data.reduce((acc, post) => {
                    acc[post.id] = 0;
                    return acc;
                }, {});
                setImageIndexes(initialIndexes);
            });
    }, []);

    const toggleLike = (id) => {
        const isLiked = likedPosts.includes(id);

        fetch(`${API_URL}/posts/${id}/like`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ like: !isLiked }),
        })
            .then((res) => res.json())
            .then((updatedPost) => {
                setPosts(posts.map((p) => (p.id === id ? updatedPost : p)));
                let updatedLikes;
                if (isLiked) {
                    updatedLikes = likedPosts.filter((postId) => postId !== id);
                } else {
                    updatedLikes = [...likedPosts, id];
                }

                setLikedPosts(updatedLikes);
                localStorage.setItem('likedPosts', JSON.stringify(updatedLikes));
            });
    };

    const datepost = posts.sort((a, b) => b.id - a.id);

    const getImageCount = (postId) => {
        const post = posts.find((p) => p.id === postId);
        return post && post.mediaCount ? post.mediaCount : 2;
    };

    const showPreviousImage = (postId) => {
        const totalImages = getImageCount(postId);
        setImageIndexes((prevIndexes) => ({
            ...prevIndexes,
            [postId]: prevIndexes[postId] === 0 ? totalImages - 1 : prevIndexes[postId] - 1,
        }));
    };

    const showNextImage = (postId) => {
        const totalImages = getImageCount(postId);
        setImageIndexes((prevIndexes) => ({
            ...prevIndexes,
            [postId]: prevIndexes[postId] === totalImages - 1 ? 0 : prevIndexes[postId] + 1,
        }));
    };

    return (
        <div>
            <div className="posts">
                <div className="titlemugram">
                    <img src={mugramicon} alt="mugram" /> <h1>موگرام</h1>
                </div>
                <Story showstory={props.showstory} stories={props.stories} />
                {datepost.map((post) => {
                    const totalImages = getImageCount(post.id);
                    const currentImageIndex = imageIndexes[post.id] || 0;
                    return (
                        <div className="post" key={post.id}>
                            {totalImages > 1 && (
                                <div className="mugram-gallery">
                                    <button
                                        onClick={() => showPreviousImage(post.id)}
                                        className="prevmugram"
                                    >
                                        ←
                                    </button>
                                    <img
                                        src={`./mugram/${post.id}/${currentImageIndex + 1}.jpg`}
                                        onError={(e) =>
                                            (e.target.src = './mugram/noimage.png')
                                        }
                                        loading="lazy"
                                        alt="Post"
                                    />
                                    <button
                                        onClick={() => showNextImage(post.id)}
                                        className="nextmugram"
                                    >
                                        →
                                    </button>
                                    <div className="image-info">
                                        {[...Array(totalImages)].map((_, index) => (
                                            <span
                                                key={index}
                                                className={`dot ${currentImageIndex === index ? 'active' : ''
                                                    }`}
                                            ></span>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {totalImages === 1 && (
                                <div className="mugram-gallery">
                                    <img
                                        src={`./mugram/${post.id}/1.jpg`}
                                        onError={(e) =>
                                            (e.target.src = './mugram/noimage.png')
                                        }
                                        loading="lazy"
                                        alt="Post"
                                    />
                                </div>
                            )}
                            <div className="likepost">
                                <p
                                    onClick={() => toggleLike(post.id)}
                                    style={{
                                        cursor: 'pointer',
                                        color: likedPosts.includes(post.id) ? 'red' : 'gray',
                                    }}
                                >
                                    {likedPosts.includes(post.id) ? '❤️' : '🤍'}
                                </p>
                                <span>{post.likes}</span>
                            </div>
                            <p>{post.text}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
